import { educationCheckActionTypes } from '@/components/modals/mistakeIntervention/Constants';

import type {
	SetMistakeInterventionIdAction,
	ToggleEducationCheckModalAction,
	ToggleReviewTopicsModalAction,
} from '@/components/modals/mistakeIntervention/types';

export function toggleEducationCheckModal(open: boolean): ToggleEducationCheckModalAction {
	return {
		type: educationCheckActionTypes.TOGGLE_EDUCATION_CHECK_MODAL,
		payload: { openEducationCheck: open },
	};
}

export function toggleReviewTopicsModal(open: boolean): ToggleReviewTopicsModalAction {
	return {
		type: educationCheckActionTypes.TOGGLE_REVIEW_TOPICS_MODAL,
		payload: { openReviewTopics: open },
	};
}

export function setMistakeInterventionId(
	mistakeInterventionId: number | null,
): SetMistakeInterventionIdAction {
	return {
		type: educationCheckActionTypes.SET_MISTAKE_INTERVENTION_ID,
		payload: { mistakeInterventionId },
	};
}
